import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from '../keys';
import type { DiscordChat, Envelope, LiveRefetch } from '../types';

/**
 * `GET /api/discord/chat` - the read-only Discord channel mirror shown on the
 * homepage. Echo's `discord.chat` ping invalidates it; `refetchInterval` is
 * the socket-drop fallback (same pattern as the live seed).
 */
export function useDiscordChat(refetchInterval: LiveRefetch = false): UseQueryResult<DiscordChat> {
  return useQuery({
    queryKey: queryKeys.discord.chat(),
    refetchInterval,
    queryFn: async () => {
      const res = await api.get<Envelope<DiscordChat>>('/discord/chat');
      return res.data;
    },
  });
}
